import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { tablesDB, DB_ID, PRODUCTS_TABLE } from "../../appwrite";
import { Query } from "appwrite";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
import Product from "./Product";
import Loading from "../../Loading";
import { useTitle } from "../../hooks/useTitle";
import { ArrowLeft } from "lucide-react";
import "./AllProducts.css";

export default function SellerStorefront() {
  const { sellerId } = useParams();
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [sellerName, setSellerName] = useState("");
  const [loading, setLoading] = useState(true);

  useTitle(sellerName ? `${sellerName} — TrendBay` : "Seller — TrendBay");

  useEffect(() => {
    (async () => {
      try {
        const res = await tablesDB.listRows({
          databaseId: DB_ID,
          tableId: PRODUCTS_TABLE,
          queries: [
            Query.equal("sellerId", sellerId),
            Query.equal("available", true),
            Query.orderDesc("$createdAt"),
            Query.limit(100),
          ],
        });
        const rows = (res.rows || []).map((r) => ({ id: r.$id, ...r }));
        setProducts(rows);
        if (rows.length > 0) setSellerName(rows[0].sellerName || "Seller");
      } catch {
        navigate("/shop/all");
      } finally {
        setLoading(false);
      }
    })();
  }, [sellerId]);

  return (
    <div className="ap-page">
      <Navbar />
      <div className="ap-wrap">
        <button className="pd-back" style={{ marginBottom: 16 }} onClick={() => navigate(-1)}>
          <ArrowLeft size={15} /> Back
        </button>

        <h1 className="ap-title">{sellerName || "Seller"}</h1>
        <p style={{ fontSize: 13, color: "#aaa", marginBottom: 24, fontFamily: "Inter, sans-serif" }}>
          {products.length} listing{products.length !== 1 ? "s" : ""}
        </p>

        {loading ? (
          <div className="ap-loading"><Loading /></div>
        ) : products.length > 0 ? (
          <div className="ap-grid">
            {products.map((p) => (
              <Product
                key={p.id}
                product_id={p.id}
                productImage={p.productImage}
                productName={p.productName}
                price={p.price}
                productDescription={p.productDescription}
                category={p.category}
              />
            ))}
          </div>
        ) : (
          <div className="ap-empty"><p>No active listings from this seller.</p></div>
        )}
      </div>
      <Footer />
    </div>
  );
}
